import { UPDATE_AUTH, ADD_ROOFTOP_OPTIONS } from 'reducers/authReducers'

import Amplify, { Hub, Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

import { GET } from 'actions/apiActions'

import { OAUTH } from 'cognito'
import API_ENDPOINTS from 'endpoints'
import { getEnvName } from 'config/env.js'

import { getRooftopId } from 'selectors/appStatusSelectors'
import { getRooftop } from 'actions/appStatusActions'
import { getDefaultRouteUrl } from 'selectors/pageStateSelectors'
import { tagDealerUser, tagCustomer } from 'actions/naughtyActions'

export const updateAuth = () => async (dispatch, getState) => {
    // TODO vet all this data, we probably don't need all of it
    // TODO this is becoming the 'boostrap app' action
    return Auth.currentSession()
      .then(() => dispatch(updateCognitoUser()))
      .then(() => dispatch(updateUserData()))
      .then(() => dispatch(tagDealerUser()))
      .then(() => dispatch(enumerateRooftopsForUser()))
      .then(() => getRooftopId(getState()) && dispatch(getRooftop()))
      .catch(() => {})
  },
  updateCognitoUser = () => async dispatch => {
    return Auth.currentAuthenticatedUser()
      .then(cognitoUser => {
        dispatch({ type: UPDATE_AUTH, payload: { cognitoUser } })
      })
      .catch(
        () => dispatch({ type: UPDATE_AUTH, payload: { cognitoUser: null } }),
        dispatch(tagCustomer()),
      )
  },
  globalSignout = () => () => {
    Auth.currentAuthenticatedUser().then(cognitoUser =>
      cognitoUser.globalSignout(() => {}, () => {}),
    )
  },
  updateUserData = () => (dispatch, getState) => {
    if (!getRooftopId(getState())) return

    return dispatch(GET.userData()).then(userData => {
      dispatch({ type: UPDATE_AUTH, payload: { userData } })
    })
  },
  setupAuthWatcher = () => dispatch => {
    Hub.listen('auth', () => {
      setTimeout(() => dispatch(updateAuth()), 1)
    })

    Amplify.configure({
      ...API_ENDPOINTS,
      Auth: OAUTH[getEnvName()],
    })

    Logger.LOG_LEVEL = window.LOG_LEVEL
  },
  enumerateRooftopsForUser = () => dispatch => {
    return dispatch(GET.availableRooftopsForUser()).then(roofOptions => {
      if (roofOptions) {
        return dispatch({ type: ADD_ROOFTOP_OPTIONS, payload: roofOptions })
      }
    })
  },
  signOut = () => (_, getState) => {
    let redirect = `${window.location.origin}${getDefaultRouteUrl(getState())}`

    Auth.signOut().then(() => window.location.assign(redirect))
  }
